module.exports = __webpack_public_path__ + "static/media/check-circle-solid.2a134079.svg";